
import { Component, Vue } from 'vue-property-decorator';
import { MutationPayload } from 'vuex';
import store from '@/store';
import router from '@/router';
import Input from '@/components/form/input.vue';
import Offcanvas from '@/components/offcanvas.vue';
import { addClient, signupClient, IClientAccount, ISignupClientAccount } from '@/api/clientAccounts';


@Component({
  name: 'AddClientAccount',
  components: { Offcanvas, Input }
})
class AddClientAccount extends Vue {
  public offcanvas = {
    active: true,
    closable: true
  };

  public form = {
    name: {
      label: 'Client Name',
      placeholder: 'Enter client name',
      type: 'text',
      required: true
    },
    email: {
      label: 'Client Email',
      placeholder: 'Enter client email',
      type: 'text',
      required: true
    },
    password: {
      label: 'Password',
      placeholder: 'Enter password',
      type: 'password',
      required: true
    },
  };

  public client: ISignupClientAccount = {
    name: "",
    email: "",
    password: "",
    emails_opt_in: false,
    // default data
  };

  public formKey: number = 0;

  public snackbar = {
    show: false,
    text: ''
  };

  public addClientPopup: any = {
    active: false,
    title: '',
    message: '',
    type: '',
    data: null
  };

  /**
   * Resets the client form data to its initial state.
   */
  public resetForm() {
    this.client.name = "";
    this.client.email = "";
    this.client.password = "";
    this.client.emails_opt_in = false;
    this.formKey++; // Force re-render
  }

  public submit() {
    signupClient(this.client).then((response) => {
      this.$emit('created', response.data);
      this.resetForm(); // Clean form data after successful submit
    });
  }

  public discard() {
    router.push('/clients');
  }

  public generatePassword() {
    const length = 12;
    const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+-=[]{}|;:,.<>?";
    let retVal = "";
    for (let i = 0, n = charset.length; i < length; ++i) {
      retVal += charset.charAt(Math.floor(Math.random() * n));
    }
    Vue.set(this.client, 'password', retVal);
    this.snackbar.text = "Random password generated";
    this.snackbar.show = true;
  }

  public copyPassword() {
    if (!this.client.password) {
      this.snackbar.text = "No password to copy";
      this.snackbar.show = true;
      return;
    }
    navigator.clipboard.writeText(this.client.password).then(() => {
      this.snackbar.text = "Password copied to clipboard";
      this.snackbar.show = true;
    }, () => {
      this.snackbar.text = "Failed to copy password";
      this.snackbar.show = true;
    });
  }
}

export default AddClientAccount;
